import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

export const authGuard = () => {
  const cookie = inject(CookieService);
  const router = inject(Router);
  const user = cookie.get('HIT-user') || '';

  if ( user ) {
    return true
  } else {
    router.navigate([
      'auth/login'
    ])
    return false
  }

};
